import React, { useState } from "react";
import { Form, Button, Spinner, InputGroup } from "react-bootstrap";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";

const LoginForm = ({
  onSubmit,
  onForgotPassword,
  disabled,
  isForgotPasswordPage,
  className = "",
  buttonClassName = "",
  forgotPasswordClassName = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form onSubmit={onSubmit} className={className}>
      <Form.Group className="username-input mb-2">
        <Form.Control
          type="text"
          placeholder="Username"
          name="username"
          required
          autoComplete="username"
          inputMode="text"
          maxLength={30}
          title="Username must be 3-30 characters long and can only include letters, numbers, dots, underscores, and hyphens."
        />
      </Form.Group>

      <Form.Group className="password-input mb-2">
        <InputGroup>
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            name="password"
            required
            autoComplete="current-password"
            pattern=".{4,100}"
            title="Password must be at least 4 characters"
          />

          <Button
            variant="outline-secondary"
            onClick={() => setShowPassword((prev) => !prev)}
            type="button"
          >
            {showPassword ? <EyeSlashFill /> : <EyeFill />}
          </Button>
        </InputGroup>
      </Form.Group>

      <div>
        <Button
          variant="success"
          className={buttonClassName}
          type="submit"
          disabled={disabled}
        >
          {disabled ? (
            <Spinner animation="border" size="sm" role="status" />
          ) : (
            "Login"
          )}
        </Button>

        <Button
          variant="link"
          onClick={onForgotPassword}
          disabled={isForgotPasswordPage}
          type="button"
          className={forgotPasswordClassName}
        >
          Forgot Password?
        </Button>
      </div>
    </Form>
  );
};

export default LoginForm;